import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='94'
			height='94'
			fill='none'
			viewBox='0 0 94 94'>
			<path
				className={fillHover}
				d='M25.892 47.433c.079-3.937 3.307-7.164 7.242-7.164 1.418 0 2.755.394 3.858 1.102.472-1.732 1.575-3.228 2.991-4.25a5.67 5.67 0 00-2.282-1.575c-1.26 1.023-2.835 1.653-4.567 1.653-1.731 0-3.306-.63-4.566-1.653a6.14 6.14 0 00-3.463 3.542c.551 1.023.787 2.125.787 3.385 0 1.575-.473 2.992-1.338 4.25.472.159.865.394 1.338.71z'></path>
			<mask
				id='mask0_228_651'
				style={{ maskType: "luminance" }}
				width='12'
				height='12'
				x='27'
				y='24'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M27.573 24.446h11.03v10.898h-11.03V24.446z'></path>
			</mask>
			<g mask='url(#mask0_228_651)'>
				<path
					className={fillHover}
					d='M33.134 35.31a5.443 5.443 0 005.432-5.433 5.442 5.442 0 00-5.432-5.431 5.442 5.442 0 00-5.432 5.431 5.443 5.443 0 005.432 5.433z'></path>
			</g>
			<path
				className={fillHover}
				d='M56.987 41.45c1.103-.709 2.44-1.102 3.858-1.102 3.936 0 7.242 3.227 7.242 7.163.394-.314.867-.63 1.339-.865-.866-1.181-1.339-2.678-1.339-4.252 0-1.18.316-2.362.787-3.385-.63-1.574-1.888-2.912-3.463-3.543-1.26 1.025-2.834 1.654-4.566 1.654-1.732 0-3.306-.63-4.566-1.654a7.868 7.868 0 00-2.283 1.575c1.417 1.18 2.52 2.677 2.991 4.41z'></path>
			<mask
				id='mask1_228_651'
				style={{ maskType: "luminance" }}
				width='12'
				height='12'
				x='55'
				y='24'
				maskUnits='userSpaceOnUse'>
				<path
					fill='#fff'
					d='M55.398 24.446h11.029v10.898h-11.03V24.446z'></path>
			</mask>
			<g mask='url(#mask1_228_651)'>
				<path
					className={fillHover}
					d='M60.846 35.31a5.443 5.443 0 005.43-5.433 5.442 5.442 0 00-5.43-5.431 5.442 5.442 0 00-5.433 5.431c.078 2.992 2.52 5.433 5.433 5.433z'></path>
			</g>
			<path
				className={fillHover}
				d='M40.377 47.511c0 .473-.078.945-.158 1.417 1.024-2.754 3.7-4.723 6.77-4.723 3.071 0 5.748 1.969 6.771 4.723-.079-.472-.157-.944-.157-1.417 0-1.81.709-3.463 1.732-4.723-.315-2.283-1.81-4.173-3.858-4.96-1.26 1.024-2.834 1.654-4.566 1.654-1.732 0-3.307-.63-4.566-1.575-2.046.788-3.542 2.677-3.857 4.96 1.18 1.18 1.89 2.834 1.89 4.644zM46.99 37.592a5.442 5.442 0 005.431-5.431 5.443 5.443 0 00-5.432-5.433 5.443 5.443 0 00-5.431 5.433c0 3.07 2.44 5.431 5.431 5.431zM26.837 51.999c-.552-1.81-1.89-3.228-3.622-3.937-1.26 1.024-2.834 1.653-4.566 1.653-1.732 0-3.306-.63-4.566-1.653-2.046.866-3.621 2.756-3.857 5.04l-.63 5.115c-.079.71.393 1.339 1.024 1.418a37.51 37.51 0 008.029.866c1.338 0 2.677-.079 3.936-.158l.236-2.282c.315-2.677 1.89-4.882 4.016-6.062zM18.65 47.826a5.443 5.443 0 005.432-5.432 5.443 5.443 0 00-5.433-5.431 5.442 5.442 0 00-5.431 5.431 5.442 5.442 0 005.431 5.432zM84.383 58.217l-.63-5.116c-.236-2.362-1.81-4.251-3.857-5.039-1.26 1.024-2.835 1.653-4.566 1.653-1.732 0-3.306-.63-4.566-1.653-1.732.71-3.07 2.126-3.621 3.937 2.125 1.259 3.7 3.463 4.015 6.062l.236 2.282c1.26.158 2.598.158 3.936.158 2.834 0 5.511-.316 8.03-.866.63-.08 1.102-.709 1.023-1.418zM75.33 47.826a5.442 5.442 0 005.431-5.432 5.442 5.442 0 00-5.431-5.431 5.443 5.443 0 00-5.433 5.431 5.443 5.443 0 005.433 5.432zM40.77 55.856c-.709-1.26-1.81-2.205-3.07-2.676-1.26 1.023-2.834 1.652-4.566 1.652-1.731 0-3.306-.63-4.566-1.652-2.047.865-3.621 2.755-3.857 5.037l-.63 5.117c-.079.63.315 1.26 1.024 1.417 2.519.552 5.274.867 8.029.867 1.102 0 2.126-.08 3.228-.158l.394-3.463c.314-2.677 1.81-4.881 4.014-6.141zM33.134 42.158a5.443 5.443 0 00-5.432 5.432 5.442 5.442 0 005.432 5.432 5.442 5.442 0 005.432-5.431c-.078-2.992-2.52-5.433-5.432-5.433zM69.268 58.217c-.314-2.361-1.81-4.25-3.857-5.037-1.26 1.023-2.834 1.652-4.566 1.652-1.732 0-3.306-.63-4.566-1.652-1.338.55-2.361 1.495-3.07 2.676 2.126 1.26 3.7 3.464 4.015 6.062l.393 3.542c1.023.079 2.126.158 3.229.158 2.833 0 5.51-.315 8.029-.867.63-.156 1.102-.787 1.023-1.417l-.63-5.117zM60.846 42.158a5.443 5.443 0 00-5.433 5.432 5.442 5.442 0 005.433 5.432 5.442 5.442 0 005.43-5.431 5.443 5.443 0 00-5.43-5.433z'></path>
			<mask
				id='mask2_228_651'
				style={{ maskType: "luminance" }}
				width='20'
				height='14'
				x='37'
				y='56'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M37.85 56.901h18.3v12.665h-18.3V56.9z'></path>
			</mask>
			<g mask='url(#mask2_228_651)'>
				<path
					className={fillHover}
					d='M55.413 62.154c-.315-2.362-1.81-4.25-3.857-5.038-1.26 1.023-2.835 1.653-4.567 1.653-1.73 0-3.305-.63-4.566-1.653-2.046.865-3.62 2.755-3.857 5.038l-.63 5.117c-.078.63.315 1.26 1.024 1.417 2.52.55 5.275.866 8.03.866 2.834 0 5.51-.315 8.03-.866.629-.157 1.102-.788 1.023-1.417l-.63-5.117z'></path>
			</g>
			<path
				className={fillHover}
				d='M46.99 46.094a5.442 5.442 0 00-5.432 5.433 5.442 5.442 0 005.431 5.431 5.442 5.442 0 005.433-5.431 5.443 5.443 0 00-5.433-5.433z'></path>
		</svg>
	);
}

export default Icon;
